// 固定翼自检
export default {
    magneticCompass: '磁罗盘',
    airspeedMeter: '空速计',
    executiveAgency: '执行机构',
    missionLoad: '任务载荷',
    heading: '航向角',
    calibration: '校准',
    airspeed: '空速',
    cleared: '清零',
    TMRA: '电机依次旋转',
    motor: '电机',
    AIOR: '舵面自动检查',
    ARL: '副翼左滚',
    ARR: '副翼右滚',
    liftingRod: '升降拉杆',
    liftPushRod: '升降推杆',
    turnLeft: '方向左转',
    turnRight: '方向右转',
    POSC: '飞控内POS计数',
    TAPO: '拍照一次',
    TPTT: '拍照十次',
    SWTT: '开始等时拍照',
    SWTTP: '停止等时拍照',
    CPD: '清空POS数据',
    tip_TMEA: '飞控/外置磁罗盘周围金属设备出现移动、变更，请进行高级校准。',
}